import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, createTextVNode as _createTextVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, mergeProps as _mergeProps, createSlots as _createSlots, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-7819d554"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "theme-container" }
const _hoisted_2 = { class: "search-container" }
const _hoisted_3 = { class: "table-container" }
const _hoisted_4 = { class: "header" }
const _hoisted_5 = { class: "statisc" }
const _hoisted_6 = { class: "handleBtns" }
const _hoisted_7 = { class: "footer" }
const _hoisted_8 = { class: "divDialog" }
const _hoisted_9 = {
  key: 0,
  class: "columnsDialog"
}
const _hoisted_10 = { class: "fixed-button" }
const _hoisted_11 = { class: "card-header" }
const _hoisted_12 = {
  key: 0,
  class: "card-header-right"
}
const _hoisted_13 = {
  key: 1,
  class: "footer"
}
const _hoisted_14 = { class: "divTableDialog" }

import { onMounted, ref, watch } from "vue";
import {
  createPageData,
  deletePageData, downloadData,
  editPageData,
  getListData,
  getPageListData,
  downloadDataByPost
} from "@/service/main/system";
import { ElForm, ElLoading, ElMessage, ElMessageBox } from 'element-plus'
import { useRoute } from 'vue-router'
import ElSelectExt from '@/components/ElSelectExt.vue'
import DynamicForm from '@/components/DynamicForm.vue'
import { usePermission } from '@/hooks/usePermission'
import { useStore } from '@/store'
import { ILoadingInstance } from 'element-plus/lib/el-loading/src/loading.type'
import DynamicSearchForm from "@/components/DynamicSearchForm.vue";
import localCache from "@/utils/cache";
import dayjs from "dayjs";
import { ce } from "@fullcalendar/core/internal-common";

const labelWidth = '120px'
const submitLabelWidth = '120px'

export default /*#__PURE__*/_defineComponent({
  __name: 'themeTableView',
  setup(__props) {

const componentMap: any = {
  ElSelectExt
}

const getComponent = (item: any) => {
  const componentName = item.component
  const component = componentMap[componentName]
  if (!component) {
    return componentName
  }
  return component
}

const activeNames = ref(['search'])
const searchForm: any = ref({})
const childSearchForm: any = ref({})
const searchFormRef = ref<InstanceType<typeof ElForm> | null>(null)
const submitForm: any = ref({})
const submitFormRef = ref<InstanceType<typeof DynamicForm> | null>(null)
const childRefList: any = ref([])
const colLayout = ref({
  xl: 6,
  lg: 8,
  md: 12,
  sm: 24,
  xs: 24
})

const handleChange = (val: string[]) => {
  console.log(val)
}
const route = useRoute()
const themeTableId: any = ref('')
// 权限
const canAdd = ref(false)
const canEdit = ref(false)
const canDelete = ref(false)
const canExport = ref(false)

const store = useStore()
const userInfo = store.state.login.userInfo
const roles = ref(userInfo.roles)
const roleIds = ref(userInfo.roles.map((role: any) => role.id))
const roleNames: any = ref(userInfo.roles.map((role: any) => role.roleName))

onMounted(() => {
  themeTableId.value = route.params.id
  importAction.value = process.env.VUE_APP_BASE_URL + `/main/themeTableView/dataImport/${themeTableId.value}`
  checkAction.value = process.env.VUE_APP_BASE_URL + `/main/themeTableView/dataCheck/${themeTableId.value}`
  initPage()
})
const themeTable: any = ref({})
const themeTableColumns = ref([])

const searchColumns = ref([])
const listColumns: any = ref([])
const businessColumns = ref([])
const tableData = ref([])
const tableCount = ref(0)
const fee = ref(0)
const rows: any = ref([])
const modalCol = ref(2)
const colSpan = ref(24 / modalCol.value)

const childThemeTable: any = ref({})
const childThemeTableColumns = ref([])
const childSearchColumns = ref([])
const childListColumns = ref([])
const childList: any = ref([])
const hasChild = ref(false)
const childRows: any = ref([])

const page = ref({
  pageNo: 1,
  pageSize: 10
})
let loadingInstance: ILoadingInstance = {} as ILoadingInstance
let tableLoadingInstance: ILoadingInstance = {} as ILoadingInstance

const urlCache: any = {}
const urlPromises: any = {}

const initPage = () => {
  loadingInstance = ElLoading.service({
    target: '.theme-container'
  })
  // 1、获取权限
  loadPermission()
  // 2、表配置
  initThemeTable()
}

const loadPermission = () => {
  canAdd.value = usePermission('themeTable' + themeTableId.value, 'add')
  canEdit.value = usePermission('themeTable' + themeTableId.value, 'edit')
  canDelete.value = usePermission('themeTable' + themeTableId.value, 'delete')
  canExport.value = usePermission('themeTable' + themeTableId.value, 'export')
}

const initThemeTable = () => {
  getListData(`/main/themeTable/${themeTableId.value}`, {}).then((res) => {
    if (res) {
      themeTable.value = res
      if (childThemeTable.value) {
        initThemeTableColumns(false)
        childThemeTable.value = res.childThemeTable
        hasChild.value = true
        initChildThemeTableColumns()
      } else {
        initThemeTableColumns(true)
      }
    } else {
      ElMessage.error('页面初始化失败')
    }
  })
}

// 监听整个 searchForm 的变化
watch(searchForm, (newVal) => {
  if (searchForm.value.report_time === null) {
    // 如果 report_time 为 null，则将其设置为空数组
    searchForm.value.report_time = ['',''];
  }
}, { deep: true });

const initThemeTableColumns = (query: boolean) => {
  getListData(`/main/themeTable/loadColumns/${themeTableId.value}`, {}).then(
    (res) => {
      themeTableColumns.value = res
      searchColumns.value = res.filter((item: any) => item.isQuery == 1)
      searchColumns.value.forEach((item: any) => {
        const tempOptions = JSON.parse(item.componentOptions)
        if (tempOptions && tempOptions.default == 'today') {
          const date = dayjs().format('YYYY-MM-DD')
          searchForm.value[item.columnName] = [date, date]
       }
      })
      listColumns.value = res.filter((item: any) => item.isList == 1)
      businessColumns.value = res.filter(
        (item: any) => item.isBusinessColumn == 1
      )
      for (let i = 0; i < listColumns.value.length; i += modalCol.value) {
        rows.value.push(listColumns.value.slice(i, i + modalCol.value))
      }
      if(query) {
        loadTableData({})
      }
    }
  )
}

const initChildThemeTableColumns = () => {
  getListData(
    `/main/themeTable/loadColumns/${childThemeTable.value.id}`,
    {}
  ).then((res) => {
    childThemeTableColumns.value = res
    childThemeTableColumns.value.forEach((item: any) => {
      const tempOptions = JSON.parse(item.componentOptions)
      if (tempOptions && tempOptions.default == 'today') {
        const date = dayjs().format('YYYY-MM-DD')
        childSearchForm.value[item.columnName] = [date, date]
      }
      if (tempOptions && item.component == 'ElSelectExt') {
        if (tempOptions.optionsType == 'state') {
          const data = store.state.login[tempOptions.dataSource]
          tempOptions.options = tempOptions.optionsProp
            ? data.map((o: string) => {
              return {
                label: o[tempOptions.optionsProp.label],
                value: o[tempOptions.optionsProp.value]
              }
            })
            : data
          item.componentOptions = JSON.stringify(tempOptions)
        } else if (tempOptions.optionsType == 'url') {
          const dataSource = tempOptions.dataSource
          if (urlCache[dataSource]) {
            tempOptions.options = tempOptions.optionsProp
              ? urlCache[dataSource].map((o: string) => {
                return {
                  label: o[tempOptions.optionsProp.label],
                  value: o[tempOptions.optionsProp.value]
                }
              })
              : urlCache[dataSource]
            item.componentOptions = JSON.stringify(tempOptions)
          } else if (urlPromises[dataSource]) {
            urlPromises[dataSource].then((cachedData: any) => {
              tempOptions.options = tempOptions.optionsProp
                ? cachedData.map((o: string) => {
                  return {
                    label: o[tempOptions.optionsProp.label],
                    value: o[tempOptions.optionsProp.value]
                  }
                })
                : cachedData
              item.componentOptions = JSON.stringify(tempOptions)
            })
          } else {
            urlPromises[dataSource] = getListData(dataSource, {}).then((res) => {
              urlCache[dataSource] = res
              tempOptions.options = tempOptions.optionsProp
                ? res.map((o: string) => {
                  return {
                    label: o[tempOptions.optionsProp.label],
                    value: o[tempOptions.optionsProp.value]
                  }
                })
                : res
              item.componentOptions = JSON.stringify(tempOptions)
              return res
            })
          }
        }
      }
    })
    childSearchColumns.value = childThemeTableColumns.value.filter((item: any) => item.isQuery == 1)
    childListColumns.value = res.filter((item: any) => item.isList == 1)
    for (let i = 0; i < childListColumns.value.length; i += modalCol.value) {
      childRows.value.push(childListColumns.value.slice(i, i + modalCol.value))
    }
    Promise.all(Object.values(urlPromises)).then(() => {
      loadTableData({})
    })
  })
}

const loadTableData = (queryInfo: any) => {
  if(queryInfo == null) {
    queryInfo = {}
  }
  tableLoadingInstance = ElLoading.service({
    target: '.el-table__body'
  })
  searchColumns.value.forEach((item: any) => {
    if (
      item.columnType == 'date' &&
      searchForm.value[item.columnName] &&
      searchForm.value[item.columnName].length > 1
    ) {
      queryInfo[item.columnName + '_begin'] =
        searchForm.value[item.columnName][0]
      queryInfo[item.columnName + '_end'] = searchForm.value[item.columnName][1]
    }
    if (
      item.columnType == 'datetime' &&
      searchForm.value[item.columnName] &&
      searchForm.value[item.columnName].length > 1
    ) {
      queryInfo[item.columnName + '_begin'] =
        searchForm.value[item.columnName][0] + ' 00:00:00'
      queryInfo[item.columnName + '_end'] = searchForm.value[item.columnName][1] + ' 23:59:59'
    }
  })
  childSearchColumns.value.forEach((item: any) => {
    if (
      item.columnType == 'date' &&
      childSearchForm.value[item.columnName] &&
      childSearchForm.value[item.columnName].length > 1
    ) {
      queryInfo[item.columnName + '_begin'] =
        childSearchForm.value[item.columnName][0]
      queryInfo[item.columnName + '_end'] = childSearchForm.value[item.columnName][1]
    }
    if (
      item.columnType == 'datetime' &&
      childSearchForm.value[item.columnName] &&
      childSearchForm.value[item.columnName].length > 1
    ) {
      queryInfo[item.columnName + '_begin'] =
        childSearchForm.value[item.columnName][0].substr(0,10) + ' 00:00:00'
      queryInfo[item.columnName + '_end'] = childSearchForm.value[item.columnName][1].substr(0,10) + ' 23:59:59'
    }
  })
  getPageListData(`/main/themeTableView/loadTableData/${themeTableId.value}`, {
    ...searchForm.value,
    ...childSearchForm.value,
    ...page.value,
    ...queryInfo
  }).then((res) => {
    console.log(res)
    tableData.value = res.list
    res.list.forEach((item: any) => {
      item.temp = -1
    })
    tableCount.value = Number(res.total)
    fee.value = Number(res.fee)
    if (loadingInstance) {
      loadingInstance.close()
    }
    if (tableLoadingInstance) {
      tableLoadingInstance.close()
    }
  })
}

const formatSearchOptions = (item: any) => {
  const result = JSON.parse(item.componentOptions)
  result.type = result.searchType
  return result
}

const handleFormUpdate = (newForm: Record<string, any>) => {
  submitForm.value = { ...newForm }
}

const handleChildFormUpdate = (newForm: Record<string, any>, cix: number) => {
  childList.value[cix] = newForm
}

const formatRules = (item: any) => {
  const result = JSON.parse(item.componentOptions)
  result.type = result.searchType
  return result.rules ? result.rules : []
}

const formatOptions = (item: any) => {
  return JSON.parse(item.componentOptions)
}

const columnFormat = (row: any, col: any, cellValue: any, index: number, column: any) => {
  const result = JSON.parse(column.componentOptions)
  if (column.component == 'DynamicJsonForm') {
    return '请通过编辑查看'
  } else if (column.component == 'el-date-picker'){
    if(column.columnFormat) {
      return cellValue ? dayjs(cellValue).format(column.columnFormat) : cellValue
    } else {
      return cellValue
    }
  } else {
    if (result && result.format) {
      return result.options.find((o: any) => o.value == cellValue)?.label
    } else {
      return cellValue
    }
  }
}

const handleSizeChange = (pageSize: number) => {
  page.value.pageSize = pageSize
  loadTableData({ pageSize })
}
const handleCurrentChange = (pageNo: number) => {
  page.value.pageNo = pageNo
  loadTableData({ pageNo })
}
const handleSearchClick = () => {
  loadTableData({})
}
const handleResetClick = () => {
  searchForm.value = {}
  childSearchForm.value = {}
  searchColumns.value.forEach((item: any) => {
    const tempOptions = JSON.parse(item.componentOptions)
    if (tempOptions && tempOptions.defaultValue == 'today') {
      const date = dayjs().format('YYYY-MM-DD')
      searchForm.value[item.columnName] = [date, date]
   }
  })
  loadTableData({})
}

// 数据操作
const handleAddClick = () => {
  modalTitle.value = '新增'
  view.value = false
  modal.value = true
  submitData.value = {}
  submitForm.value = {}
  childList.value = [{}]
}
const selectRows: any = ref([])
const handleSelectionChange = (selection: any) => {
  if (selection.length > 0) {
    selectRows.value = selection.map((item: any) => item.id)
  } else {
    selectRows.value = []
  }
}

const handleMerge = () => {
  if (selectRows.value.length > 1) {
    const selectList = tableData.value.filter((row: any) => selectRows.value.includes(row.id));
    // 从selectList获取不重复的客户姓名字段，如果超出一个，则提示存在客户名称不相符数据，是否继续
    const customerNameList = selectList.map((item: any) => item.customer_name)
    console.log('customerNameList', customerNameList)
    const customerNameSet = new Set(customerNameList)
    if (customerNameSet.size > 1) {
      ElMessageBox.confirm('存在客户名称不相符数据，是否继续？', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        editPageData(`/main/themeTableView/mergeData/${themeTableId.value}`, {
          ids: selectRows.value.join(','),
        }).then((res) => {
          ElMessage({
            type: 'success',
            message: '合并成功'
          })
          loadTableData({})
        })
      })
    } else {
      handleMergeF()
    }
  } else {
    ElMessage({
      type: 'warning',
      message: '请选择要合并的数据,至少两条'
    })
  }
}

const handleMergeF = () => {
  ElMessageBox.confirm('是否确认合并数据？', '提示', {
      confirmButtonText: '确定',
      cancelButtonText: '取消',
      type: 'warning'
    }).then(() => {
        editPageData(`/main/themeTableView/mergeData/${themeTableId.value}`, {
          ids: selectRows.value.join(','),
        }).then((res) => {
          ElMessage({
            type: 'success',
            message: '合并成功'
          })
        })
    })
}

const handleDownload = () => {
  downloadData(
    `/main/themeTableView/downloadTemplate/${themeTableId.value}`,{},
    'blob'
  ).then((res) => {
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    const down = document.createElement('a')
    down.download =
      themeTable.value.tableComment + '导入模板.xlsx'
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  })
}

const importAction = ref()
const checkAction = ref()


const headers = ref({})
const token = localCache.getCache('token')
headers.value = {
  Authorization: `Bearer ${token}`
}

const handleImportError = (res: any) => {
  console.log(res)
}

const handleImportSuccess = (res: any) => {
  if (res.data == '文件上传成功并解析完成') {
    loadTableData({})
    ElMessage({
      type: 'success',
      message: '导入成功'
    })
  } else {
    ElMessage({
      type: 'error',
      dangerouslyUseHTMLString: true,
      message: res.data
    })
  }
}


const handleExport = () => {
  const dictMap: any = {}
  const queryInfo: any = {}
  childSearchColumns.value.forEach((item: any) => {
    const data = JSON.parse(item.componentOptions)
    if(data.needConvert) {
      const options = JSON.parse(item.componentOptions).options
      const result = options.reduce((acc: any, item: any) => {
        acc[item.value] = item.label;
        return acc;
      }, {});
      dictMap[item.columnName] = result
    }
    if (
      item.columnType == 'date' &&
      childSearchForm.value[item.columnName] &&
      childSearchForm.value[item.columnName].length > 1
    ) {
      queryInfo[item.columnName + '_begin'] =
        childSearchForm.value[item.columnName][0]
      queryInfo[item.columnName + '_end'] = childSearchForm.value[item.columnName][1]
    }
    if (
      item.columnType == 'datetime' &&
      childSearchForm.value[item.columnName] &&
      childSearchForm.value[item.columnName].length > 1
    ) {
      queryInfo[item.columnName + '_begin'] =
        childSearchForm.value[item.columnName][0].substr(0,10) + ' 00:00:00'
      queryInfo[item.columnName + '_end'] = childSearchForm.value[item.columnName][1].substr(0,10) + ' 23:59:59'
    }
  })

  searchColumns.value.forEach((item: any) => {
    const data = JSON.parse(item.componentOptions)
    if(data.needConvert) {
      const options = JSON.parse(item.componentOptions).options
      const result = options.reduce((acc: any, item: any) => {
        acc[item.value] = item.label;
        return acc;
      }, {});
      dictMap[item.columnName] = result
    }
    if (
      item.columnType == 'date' &&
      searchForm.value[item.columnName] &&
      searchForm.value[item.columnName].length > 1
    ) {
      queryInfo[item.columnName + '_begin'] =
        searchForm.value[item.columnName][0]
      queryInfo[item.columnName + '_end'] = searchForm.value[item.columnName][1]
    }
    if (
      item.columnType == 'datetime' &&
      searchForm.value[item.columnName] &&
      searchForm.value[item.columnName].length > 1
    ) {
      queryInfo[item.columnName + '_begin'] =
        searchForm.value[item.columnName][0] + ' 00:00:00'
      queryInfo[item.columnName + '_end'] = searchForm.value[item.columnName][1] + ' 23:59:59'
    }
  })

  const loadingInstance = ElLoading.service({
    lock: true,
    text: '数据下载中...',
    background: 'rgba(0, 0, 0, 0.5)'
  })

  downloadDataByPost(
    `/main/themeTableView/download/${themeTableId.value}`,
    {
      ...searchForm.value,
      ...childSearchForm.value,
      ...queryInfo,
      'dict': dictMap
    },
    'blob'
  ).then((res) => {
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    })
    const down = document.createElement('a')
    down.download =
      themeTable.value.tableComment +
      ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '') +
      '.xlsx'
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  }).finally(() => {
    loadingInstance.close()
  })
}

const handleExportStatistic = () => {
  getPageListData(
    `/main/themeTableView/statistic/${themeTableId.value}`,
    {
      "startTime":childSearchForm.value["created_time"][0],
      "endTime":childSearchForm.value["created_time"][1]
    },
    'blob'
  ).then((res) => {
    const blob = new Blob([res], {
      type: 'application/octet-stream'
    }) //处理文档流
    const down = document.createElement('a')
    down.download =
      themeTable.value.tableComment +
      ts2str(new Date().getTime()).replaceAll(/:| |-/gi, '') +
      '.xlsx'
    down.style.display = 'none'
    down.href = URL.createObjectURL(blob)
    document.body.appendChild(down)
    down.click()
    URL.revokeObjectURL(down.href)
    document.body.removeChild(down)
  })
}

const view = ref(false)
const handleViewClick = (row: any) => {
  view.value = true
  modalTitle.value = '查看'
  modal.value = true
  submitData.value = row
  convertStringToArray()
  getListData(
    `/main/themeTableView/loadChildTableData/${childThemeTable.value.id}/${row.id}`,
    {}
  ).then((res) => {
    if (res.length > 0) {
      childList.value = res
      row.childList = res
    } else {
      childList.value = [{}]
      row.childList = []
    }
  })
}

const modalTable = ref(false)
const handleViewDetail = (row: any) => {
  view.value = true
  modalTitle.value = '明细'
  modalTable.value = true
  submitData.value = row
  getListData(
    `/main/themeTableView/loadChildTableData/${childThemeTable.value.id}/${row.id}`,
    {}
  ).then((res) => {
    if (res.length > 0) {
      childList.value = res
      row.childList = res
    } else {
      childList.value = [{}]
      row.childList = []
    }
  })
}
const getEditPermi = (row: any) => {
  if (roleNames.value.indexOf('ROLE_财务-成交单') > -1) {
    return canEdit
  } else {
    return canEdit && row.check_status != 1
  }
}

const getDeletePermi = (row: any) => {
  if (roleNames.value.indexOf('ROLE_财务-成交单') > -1) {
    return canDelete
  } else {
    return canDelete && row.check_status != 1
  }
}

const handleEditClick = (row: any) => {
  view.value = false
  modalTitle.value = '编辑'
  modal.value = true
  submitData.value = row
  convertStringToArray()
  getListData(
    `/main/themeTableView/loadChildTableData/${childThemeTable.value.id}/${row.id}`,
    {}
  ).then((res) => {
    if (res.length > 0) {
      childList.value = res
      row.childList = res
    } else {
      childList.value = [{}]
      row.childList = []
    }
  })
}
const handleDeleteClick = (row: any) => {
  ElMessageBox.confirm('确定删除吗？', '提示', {
    confirmButtonText: '确认',
    cancelButtonText: '取消',
    type: 'warning'
  }).then(() => {
    deletePageData(
      `/main/themeTableView/deletePageData/${themeTableId.value}/${row.id}`
    ).then((res) => {
      ElMessage.success('删除成功')
      loadTableData({})
    })
  })
}

const cancelAndClose = () => {
  if (modal.value && modalTable.value) {
    modal.value = false
    submitData.value = {}
    submitForm.value = {}
  } else if (modal.value) {
    modal.value = false
    submitData.value = {}
    submitForm.value = {}
    childList.value = []
  } else if (modalTable.value) {
    modalTable.value = false
    submitData.value = {}
    submitForm.value = {}
    childList.value = []
  }
}
const submitData: any = ref({})
const handleSubmitClick = () => {
  submitFormRef.value?.formRef?.validate(async (valid: any) => {
    if (valid) {
      let allValid = true;
      for (let i = 0; i < childRefList.value.length; i++) {
        if(childRefList.value[i]) {
          const isValid = await childRefList.value[i].validateForm();
          if (!isValid) {
            allValid = false;
            break;
          }
        }
      }
      if (allValid) {
        convertArrayToString()
        submitData.value.childList = childList.value
        if (submitData.value.id) {
          editPageData(
            `/main/themeTableView/editPageData/${themeTableId.value}/${submitData.value.id}`,
            submitData.value
          ).then((res) => {
            ElMessage.success('修改成功')
            cancelAndClose()
            loadTableData({})
          })
        } else {
          createPageData(
            `/main/themeTableView/createPageData/${themeTableId.value}`,
            submitData.value
          ).then((res) => {
            ElMessage.success('新增成功')
            cancelAndClose()
            loadTableData({})
          })
        }
      } else {
        return false
      }
    } else {
      return false
    }
  })
}

const convertArrayToString = () => {
  for (let i = 0; i < listColumns.value.length; i++) {
    const column = listColumns.value[i]
    console.log(column)
    const options = formatOptions(column)
    //
      if (column.component == 'ElSelectExt' && options.multiple) {
        if (submitForm.value[column.columnName]) {
          submitData.value[column.columnName] =
            submitForm.value[column.columnName].join('+')
        }
      } else {
        submitData.value[column.columnName] =
          submitForm.value[column.columnName]
      }
    // }
  }
}

const convertStringToArray = () => {
  for (let i = 0; i < listColumns.value.length; i++) {
    const column = listColumns.value[i]
    const options = formatOptions(column)
    if (submitData.value[column.columnName]) {
      if (column.component == 'ElSelectExt' && options.multiple) {
        submitForm.value[column.columnName] =
          submitData.value[column.columnName].split('+')
      } else {
        submitForm.value[column.columnName] =
          submitData.value[column.columnName]
      }
    }
  }
}

// 新增-编辑
const modalTitle = ref('')
const modal = ref(false)

const handleAddChildClick = () => {
  childList.value.push({})
}

const handleDeleteChildClick = (cix: number, child: any) => {
  if (child.id) {
    ElMessageBox.confirm(
      '确定删除吗？',
      '提示: 此操作不经提交直接删除相应数据',
      {
        confirmButtonText: '确认',
        cancelButtonText: '取消',
        type: 'warning'
      }
    ).then(() => {
      deletePageData(
        `/main/themeTableView/deletePageData/${childThemeTable.value.id}/${child.id}`
      ).then((res) => {
        ElMessage.success('删除成功')
        childList.value.splice(cix, 1)
      })
    })
  } else {
    childList.value.splice(cix, 1)
  }
}

const ts2str = (ts: any) => {
  let date = new Date(parseInt(ts))
  let Year = date.getFullYear()
  let Moth =
    date.getMonth() + 1 < 10 ? '0' + (date.getMonth() + 1) : date.getMonth() + 1
  let Day = date.getDate() < 10 ? '0' + date.getDate() : date.getDate()
  let Hour = date.getHours() < 10 ? '0' + date.getHours() : date.getHours()
  let Minute =
    date.getMinutes() < 10 ? '0' + date.getMinutes() : date.getMinutes()
  let Second =
    date.getSeconds() < 10 ? '0' + date.getSeconds() : date.getSeconds()
  let GMT =
    Year + '-' + Moth + '-' + Day + ' ' + Hour + ':' + Minute + ':' + Second
  return GMT
}

const handleSwitchChange = (val: any, row: any, column: any) => {
  console.log(val)
  submitData.value = row
  convertStringToArray()
  row[column.columnName] = val
  editPageData(
    `/main/themeTableView/editPageData/${themeTableId.value}/${submitData.value.id}`,
    submitData.value
  ).then((res) => {
    ElMessage.success('修改成功')
    cancelAndClose()
    loadTableData({})
  })
}


return (_ctx: any,_cache: any) => {
  const _component_el_button = _resolveComponent("el-button")!
  const _component_ElCollapseItem = _resolveComponent("ElCollapseItem")!
  const _component_ElCollapse = _resolveComponent("ElCollapse")!
  const _component_el_card = _resolveComponent("el-card")!
  const _component_el_upload = _resolveComponent("el-upload")!
  const _component_el_table_column = _resolveComponent("el-table-column")!
  const _component_el_switch = _resolveComponent("el-switch")!
  const _component_el_table = _resolveComponent("el-table")!
  const _component_el_pagination = _resolveComponent("el-pagination")!
  const _component_el_affix = _resolveComponent("el-affix")!
  const _component_el_dialog = _resolveComponent("el-dialog")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_component_ElCollapse, {
        modelValue: activeNames.value,
        "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((activeNames).value = $event)),
        onChange: handleChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_ElCollapseItem, {
            title: "",
            name: "search"
          }, {
            default: _withCtx(() => [
              (childSearchColumns.value.length > 0)
                ? (_openBlock(), _createBlock(DynamicSearchForm, {
                    key: 0,
                    modelValue: childSearchForm.value,
                    "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((childSearchForm).value = $event)),
                    "search-columns": childSearchColumns.value,
                    "label-width": labelWidth,
                    "col-layout": colLayout.value
                  }, null, 8, ["modelValue", "search-columns", "col-layout"]))
                : _createCommentVNode("", true),
              _createVNode(DynamicSearchForm, {
                modelValue: searchForm.value,
                "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((searchForm).value = $event)),
                "search-columns": searchColumns.value,
                "label-width": labelWidth,
                "col-layout": colLayout.value
              }, null, 8, ["modelValue", "search-columns", "col-layout"]),
              _createElementVNode("div", {
                class: _normalizeClass(
              searchColumns.value.length % 4 > 0 ? 'handle-btns-last' : 'handle-btns'
            )
              }, [
                _createVNode(_component_el_button, {
                  icon: "el-icon-refresh",
                  onClick: handleResetClick
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("重置")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  icon: "el-icon-search",
                  onClick: handleSearchClick
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("搜索")
                  ]),
                  _: 1
                })
              ], 2)
            ]),
            _: 1
          })
        ]),
        _: 1
      }, 8, ["modelValue"])
    ]),
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("div", _hoisted_5, [
          (fee.value > 0)
            ? (_openBlock(), _createBlock(_component_el_card, { key: 0 }, {
                default: _withCtx(() => [
                  _createTextVNode(" 到账金额: " + _toDisplayString(fee.value), 1)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _createElementVNode("div", _hoisted_6, [
          (canAdd.value)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 0,
                type: "primary",
                onClick: handleAddClick
              }, {
                default: _withCtx(() => [
                  _createTextVNode("新增")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (canAdd.value)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 1,
                type: "primary",
                onClick: handleMerge
              }, {
                default: _withCtx(() => [
                  _createTextVNode("合并")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (canAdd.value && roleNames.value.indexOf('ROLE_财务-成交单') > -1)
            ? (_openBlock(), _createBlock(_component_el_upload, {
                key: 2,
                style: {"display":"inline-block","margin-left":"10px","margin-right":"10px"},
                action: checkAction.value,
                headers: headers.value,
                accept: ".xls,.xlsx",
                "on-success": handleImportSuccess,
                "on-error": handleImportError,
                "show-file-list": false
              }, {
                default: _withCtx(() => [
                  (canAdd.value)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("批量核算")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["action", "headers"]))
            : _createCommentVNode("", true),
          (canAdd.value && roleNames.value.indexOf('ROLE_财务-成交单') > -1)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 3,
                type: "primary",
                onClick: handleDownload
              }, {
                default: _withCtx(() => [
                  _createTextVNode("下载模板")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (canAdd.value && roleNames.value.indexOf('ROLE_财务-成交单') > -1)
            ? (_openBlock(), _createBlock(_component_el_upload, {
                key: 4,
                style: {"display":"inline-block","margin-left":"10px","margin-right":"10px"},
                action: importAction.value,
                headers: headers.value,
                accept: ".xls,.xlsx",
                "on-success": handleImportSuccess,
                "on-error": handleImportError,
                "show-file-list": false
              }, {
                default: _withCtx(() => [
                  (canAdd.value)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("数据导入")
                        ]),
                        _: 1
                      }))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }, 8, ["action", "headers"]))
            : _createCommentVNode("", true),
          (canExport.value)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 5,
                type: "primary",
                onClick: handleExport
              }, {
                default: _withCtx(() => [
                  _createTextVNode(" 数据导出")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true),
          (canAdd.value)
            ? (_openBlock(), _createBlock(_component_el_button, {
                key: 6,
                type: "primary",
                onClick: handleExportStatistic
              }, {
                default: _withCtx(() => [
                  _createTextVNode("统计数据")
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ])
      ]),
      _createVNode(_component_el_table, {
        data: tableData.value,
        stripe: "",
        border: "",
        fit: "",
        style: {"width":"100%"},
        onSelectionChange: handleSelectionChange
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table_column, {
            type: "selection",
            width: "55"
          }),
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(listColumns.value, (column, index) => {
            return (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
              key: index,
              align: "center",
              prop: column.columnName,
              label: column.columnComment,
              width: column.columnWidth,
              formatter: (row, col, cellValue, idx) => columnFormat(row, col, cellValue, idx, column),
              ref_for: true
            }, formatOptions(column)), _createSlots({ _: 2 }, [
              (column.component == 'el-switch')
                ? {
                    name: "default",
                    fn: _withCtx((scope) => [
                      (scope.row[column.columnName])
                        ? (_openBlock(), _createBlock(_component_el_switch, _mergeProps({
                            key: 0,
                            modelValue: scope.row[column.columnName],
                            "onUpdate:modelValue": ($event: any) => ((scope.row[column.columnName]) = $event),
                            ref_for: true
                          }, formatOptions(column), {
                            disabled: roleNames.value.indexOf('ROLE_财务-成交单') == -1 || !canEdit.value,
                            onChange: (val) => handleSwitchChange(val, scope.row, column)
                          }), null, 16, ["modelValue", "onUpdate:modelValue", "disabled", "onChange"]))
                        : (_openBlock(), _createBlock(_component_el_switch, _mergeProps({
                            key: 1,
                            modelValue: scope.row.temp,
                            "onUpdate:modelValue": ($event: any) => ((scope.row.temp) = $event),
                            ref_for: true
                          }, formatOptions(column), {
                            onChange: (val) => handleSwitchChange(val, scope.row, column)
                          }), null, 16, ["modelValue", "onUpdate:modelValue", "onChange"]))
                    ]),
                    key: "0"
                  }
                : undefined
            ]), 1040, ["prop", "label", "width", "formatter"]))
          }), 128)),
          (listColumns.value.length > 0)
            ? (_openBlock(), _createBlock(_component_el_table_column, {
                key: 0,
                align: "center",
                width: "300",
                label: "操作",
                fixed: "right"
              }, {
                default: _withCtx((scope) => [
                  _createVNode(_component_el_button, {
                    type: "primary",
                    size: "mini",
                    onClick: ($event: any) => (handleViewClick(scope.row))
                  }, {
                    default: _withCtx(() => [
                      _createTextVNode("查看")
                    ]),
                    _: 2
                  }, 1032, ["onClick"]),
                  (hasChild.value)
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 0,
                        type: "primary",
                        size: "mini",
                        onClick: ($event: any) => (handleViewDetail(scope.row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("明细")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (getEditPermi(scope.row))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 1,
                        type: "primary",
                        size: "mini",
                        onClick: ($event: any) => (handleEditClick(scope.row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("编辑")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true),
                  (getDeletePermi(scope.row))
                    ? (_openBlock(), _createBlock(_component_el_button, {
                        key: 2,
                        type: "danger",
                        size: "mini",
                        onClick: ($event: any) => (handleDeleteClick(scope.row))
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("删除")
                        ]),
                        _: 2
                      }, 1032, ["onClick"]))
                    : _createCommentVNode("", true)
                ]),
                _: 1
              }))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["data"]),
      _createElementVNode("div", _hoisted_7, [
        _createVNode(_component_el_pagination, {
          "current-page": page.value.pageNo,
          "page-sizes": [10, 20, 30, 40, 100],
          "page-size": page.value.pageSize,
          layout: "total, sizes, prev, pager, next, jumper",
          total: tableCount.value,
          onSizeChange: handleSizeChange,
          onCurrentChange: handleCurrentChange
        }, null, 8, ["current-page", "page-size", "total"])
      ])
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_el_dialog, {
        top: "2vh",
        "lock-scroll": "",
        modelValue: modal.value,
        "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((modal).value = $event)),
        title: modalTitle.value,
        "destroy-on-close": "",
        onClose: cancelAndClose
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_card, {
            header: "基本信息",
            class: "modalDailog"
          }, {
            default: _withCtx(() => [
              _createVNode(DynamicForm, {
                ref_key: "submitFormRef",
                ref: submitFormRef,
                model: submitForm.value,
                "can-edit": canEdit.value && !view.value,
                "label-width": submitLabelWidth,
                rows: rows.value,
                "role-ids": roleIds.value,
                "col-span": colSpan.value,
                "onUpdate:model": handleFormUpdate
              }, null, 8, ["model", "can-edit", "rows", "role-ids", "col-span"])
            ]),
            _: 1
          }),
          (hasChild.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_9, [
                _createElementVNode("div", _hoisted_10, [
                  _createVNode(_component_el_affix, { offset: 120 }, {
                    default: _withCtx(() => [
                      (canAdd.value && !view.value)
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            type: "primary",
                            onClick: handleAddChildClick
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("添加")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(childList.value, (child, cix) => {
                  return (_openBlock(), _createBlock(_component_el_card, { key: cix }, {
                    header: _withCtx(() => [
                      _createElementVNode("div", _hoisted_11, [
                        _createElementVNode("span", null, _toDisplayString(childThemeTable.value.tableComment + (cix + 1)), 1)
                      ]),
                      (cix > 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_12, [
                            (canDelete.value && !view.value)
                              ? (_openBlock(), _createBlock(_component_el_button, {
                                  key: 0,
                                  type: "danger",
                                  size: "mini",
                                  onClick: ($event: any) => (handleDeleteChildClick(cix, child))
                                }, {
                                  default: _withCtx(() => [
                                    _createTextVNode("删除")
                                  ]),
                                  _: 2
                                }, 1032, ["onClick"]))
                              : _createCommentVNode("", true)
                          ]))
                        : _createCommentVNode("", true)
                    ]),
                    default: _withCtx(() => [
                      _createVNode(DynamicForm, {
                        ref_for: true,
                        ref: el => { childRefList.value[cix] = el },
                        index: cix,
                        model: child,
                        "can-edit": canEdit.value && !view.value,
                        "label-width": submitLabelWidth,
                        rows: childRows.value,
                        columns: childListColumns.value,
                        "role-ids": roleIds.value,
                        "col-span": colSpan.value,
                        "onUpdate:model": handleChildFormUpdate
                      }, null, 8, ["index", "model", "can-edit", "rows", "columns", "role-ids", "col-span"])
                    ]),
                    _: 2
                  }, 1024))
                }), 128))
              ]))
            : _createCommentVNode("", true),
          (canEdit.value && !view.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_13, [
                _createVNode(_component_el_button, { onClick: cancelAndClose }, {
                  default: _withCtx(() => [
                    _createTextVNode("取消")
                  ]),
                  _: 1
                }),
                _createVNode(_component_el_button, {
                  type: "primary",
                  onClick: handleSubmitClick
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("提交")
                  ]),
                  _: 1
                })
              ]))
            : _createCommentVNode("", true)
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ]),
    _createElementVNode("div", _hoisted_14, [
      _createVNode(_component_el_dialog, {
        width: "75%",
        "lock-scroll": "",
        modelValue: modalTable.value,
        "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((modalTable).value = $event)),
        title: modalTitle.value,
        "destroy-on-close": "",
        onClose: cancelAndClose
      }, {
        default: _withCtx(() => [
          _createVNode(_component_el_table, {
            data: childList.value,
            stripe: "",
            border: "",
            fit: "",
            style: {"width":"100%"}
          }, {
            default: _withCtx(() => [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(childListColumns.value, (column, index) => {
                return (_openBlock(), _createBlock(_component_el_table_column, _mergeProps({
                  key: index,
                  align: "center",
                  prop: column.columnName,
                  label: column.columnComment,
                  width: column.columnWidth,
                  formatter: (row, col, cellValue, idx) => columnFormat(row, col, cellValue, idx, column),
                  ref_for: true
                }, formatOptions(column)), null, 16, ["prop", "label", "width", "formatter"]))
              }), 128)),
              (childListColumns.value.length > 0)
                ? (_openBlock(), _createBlock(_component_el_table_column, {
                    key: 0,
                    align: "center",
                    width: "250",
                    label: "操作",
                    fixed: "right"
                  }, {
                    default: _withCtx((scope) => [
                      (getEditPermi(submitData.value))
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 0,
                            type: "primary",
                            size: "mini",
                            onClick: _cache[4] || (_cache[4] = ($event: any) => (handleEditClick(submitData.value)))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("编辑")
                            ]),
                            _: 1
                          }))
                        : _createCommentVNode("", true),
                      (getDeletePermi(submitData.value))
                        ? (_openBlock(), _createBlock(_component_el_button, {
                            key: 1,
                            type: "danger",
                            size: "mini",
                            onClick: ($event: any) => (handleDeleteChildClick(scope.$index, scope.row))
                          }, {
                            default: _withCtx(() => [
                              _createTextVNode("删除")
                            ]),
                            _: 2
                          }, 1032, ["onClick"]))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  }))
                : _createCommentVNode("", true)
            ]),
            _: 1
          }, 8, ["data"])
        ]),
        _: 1
      }, 8, ["modelValue", "title"])
    ])
  ]))
}
}

})